/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/updateIntegrationConfigurationOverrides';

export type UpdateIntegrationConfigurationPathParams = NonNullable<
  operations['updateIntegrationConfiguration']['parameters']['path']
>;

export type UpdateIntegrationConfigurationRequestBody = OperationRequestBodyContent<
  operations['updateIntegrationConfiguration']
>;

export interface Input extends UpdateIntegrationConfigurationPathParams {
  apiVersion?: string;
  body: UpdateIntegrationConfigurationRequestBody;
}

export async function updateIntegrationConfiguration(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/integration-configurations/{integrationConfigurationId}', {
    params: { path },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
